import { Injectable } from '@angular/core';
import { Http, Response, Headers, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

//import "../utils/utility";
import { TmReview, TmReview_Product, TmReview_ProductReviewDetail } from '../model/powerreview';
import { TmPowerReviewRequest } from '../model/request/powerreview-request';


export class PowerReviewsBase {
    protected readReviewBaseUrl = 'https://readservices.powerreviews.com/g/12623/product/'; //merchant_group_id = 12623, merchant_id = 3077
    protected headers: Headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: 'b98bac63-38d8-44ac-9c40-3e650c5439a6',
    });

    constructor() {}
static ctorParameters() { return [  ]; }}


export class PowerReviews_ReadReview extends PowerReviewsBase {
    constructor(private http: Http) {
        super();
    }

    get(reviewReq: TmPowerReviewRequest) {
        const query = this.readReviewBaseUrl + reviewReq.itemNo + '/q/product_detail';
        const urlParams: URLSearchParams = new URLSearchParams();

        if (reviewReq.page != undefined) {
            urlParams.set('reviews.paging.page', reviewReq.page.toString());
        }
        if (reviewReq.pageSize != undefined) {
            urlParams.set('reviews.paging.size', reviewReq.pageSize.toString());
        }
        if (reviewReq.sortKey != undefined) {
            urlParams.set('reviews.sorts', reviewReq.sortKey);
        }

        return this.http.get(query, { headers: this.headers, search: urlParams }).map((resp) => {
            const totalProducts = resp.json().total;
            if (totalProducts == 0) {
                //
            } else {
                let reviewIndex = 0;
                const productReviewResults: TmReview_Product[] = (resp.json() as TmReview).results;
                reviewIndex = productReviewResults.findIndex((x) => x.metrics.review_count > 0);
                const productReviews: TmReview_Product =
                    reviewIndex > -1 ? productReviewResults[reviewIndex] : productReviewResults[0];
                return productReviews;
            }
        });
    }
}(PowerReviews_ReadReview as any).ctorParameters = function () { return [ { type: Http } ]; }



// WEBPACK FOOTER //
// C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/ngc-webpack??ref--0-1!C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/angular2-template-loader!../external_api/service/powerreviews.service.ts